module.exports = __webpack_public_path__ + "static/media/camping.20b2c34b.webp";